---
title: 'Step 2: Configure Collector'
install_track_title: 'Log Insights: Setup (Self-Managed)'
backlink_href: /docs/log-insights/setup
backlink_title: 'Log Insights: Setup'
---

import imgLogInsightsScreenshot from '../log_insights_screenshot.png'

export const ImgLogInsightsScreenshot = () => <img src={imgLogInsightsScreenshot} alt='Screenshot of pganalyze Log Insights feature' />

We can now configure the log directory for the collector, by adding the `db_log_location` setting,
similar to this:

```bash
db_log_location = [log location discovered in Step 1]
```

Then, use the `--test-logs` option of the collector to verify that log collection and parsing works:

```bash
sudo pganalyze-collector --test-logs --reload
```

In the successful case, the log output will look like this:

<CodeBlock language="text" hideCopy="true">
{`2021/02/17 11:50:27 I Running collector test with pganalyze-collector 0.36.0
2021/02/17 11:50:27 I [server1] Testing log collection (local)...
2021/02/17 11:50:33 I [server1]   Local log test successful
2021/02/17 11:50:33 I Re-running log test with reduced privileges of "pganalyze" user (uid = 107, gid = 113)
2021/02/17 11:50:34 I [server1] Testing log collection (local)...
2021/02/17 11:50:46 I [server1]   Local log test successful
2021/02/17 11:50:47 I Successfully reloaded pganalyze collector (PID 123)`}
</CodeBlock>

The collector should now be processing logs and they should show up in pganalyze shortly.

If you get an error about your Postgres `log_line_prefix`, check our
[troubleshooting documentation](https://pganalyze.com/docs/log-insights/setup/self-managed/troubleshooting#collector-test-error-log_line_prefix-not-supported).

If logs take longer than a few minutes, try restarting the collector:

```bash
sudo systemctl restart pganalyze-collector
```

<PublicOnly>
  <p>
    Once ready, you will see log events on the Log Insights page in pganalyze.
  </p>
  <p>
    <ImgLogInsightsScreenshot />
  </p>
  <p>
    We recommend setting up <a href="/docs/explain/setup">Automated EXPLAIN</a> as
    a follow-up step, to automatically EXPLAIN slow queries in Postgres.
  </p>
</PublicOnly>
